<template>
  <el-dialog
    class="add-edit"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="modify"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="所属系统:">
            <el-input v-model="modalData.systemName" style="width: 440px;" disabled></el-input>
        </el-form-item>

        <el-form-item label="菜单名称:" prop="name">
          <el-input v-model="formData.name" placeholder="请输入菜单名称" style="width: 440px;"></el-input>
          <span class="input-tips">*必填，2-15位字符</span>
        </el-form-item>

        <el-form-item label="父菜单:" prop="parentCode">
          <el-select  :disabled="formType === 'add'" v-model="formData.parentCode" class="form-item__input" style="width: 440px;">
            <el-option label="无" value="ROOT" ></el-option>
            <el-option
              v-for="(item,index) in datalist"
              :key="index"
              :label="item.showName"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="菜单路径:">
          <el-input v-model="formData.url" placeholder="请输入菜单路径" style="width: 440px;"></el-input>
        </el-form-item>

        <el-form-item label="菜单顺序:" prop="sort">
          <el-input v-model="formData.sort" placeholder="请输入菜单顺序" style="width: 440px;"></el-input>
          <span class="input-tips">*选填，仅支持整数</span>
        </el-form-item>

        <el-form-item label="是否显示:" prop="status">
          <el-select v-model="formData.status" class="form-item__input" style="width: 440px;">
            <el-option
              v-for="item in formData.booleans"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="菜单图标样式:" prop="icon"  v-if="modalData.level===1">
          <el-input v-model="formData.icon" placeholder="请输入菜单图标样式" style="width: 440px;"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">确认</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import OSS from "ali-oss";
export default {
  name: "add-edit",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      client: null,
      level:1,
      datalist:[],
      formData: {
        systemId:"",
        name: "",
        parentCode: "ROOT",
        url: "",
        icon: "",
        sort: "",
        status: 1,
        booleans: [{ value: 1, label: "显示" }, { value: 2, label: "隐藏" }]
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
        name: [
          { required: true, message: "请输入菜单名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 15) {
                callback(new Error("2-15位字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        parentCode: [{ required: true, message: "请选择!", trigger: "blur" }],
        sort: [{ required: true, message: "请输入菜单顺序!", trigger: "blur" },
              {
            validator: (rule, value, callback) => {
              let reg = /^[0-9]+$/;
              if (!reg.test(value)) {
                callback(new Error("请输入数字!"));
              } else {
                callback();
              }
            }
          }],
        status: [{ required: true, message: "请选择!", trigger: "blur" }],
        icon: [
          { required: true, message: "请输入菜单图标样式!", trigger: "blur" }
        ]
      }
    };
  },
     watch: {
      "formData.parentCode": {
        handler: function(val){
        if (val !== "") {
          this.datalist.find(ele => {
            if(ele.code == val) {
              this.formData.code= ele.parentCode;
            }
          });
        }
      },
    },
  },
  methods: {
    // 关闭选择品牌
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    $_submit() {
      if (this.formData.name === "") {
        $MessageBox.alert({ content: "请输入菜单名称" });
        return false;
      }
      this.systemId = this.modalData.cid;
      this.$refs["modify"].validate(valid => {
        if (valid) {
          let {
            name,
            parentCode,
            url,
            icon,
            sort,
            status,
            systemId
          } = this.formData;
          let postData = {
            name,
            parentCode,
            url,
            icon,
            sort,
            status,
            systemId:this.systemId
          };
          const doPost = (action, postData) => {
            self.$service.post(action, postData).then(result => {
              self.isLoading = false;
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.visible = false;
                    self.$emit("callback");
                  }
                });
              }
            });
          };
          let action="";
          const self = this;
          if (self.formType === "add") {
            action = "functionSave";
            self.isLoading = true;
            doPost(action,postData);
          }
           postData.systemId=this.systemId
            if (self.formType === "edit") {
            action = "functionModify";
            Object.assign(postData, { fid: this.formData.fid});
             $MessageBox.confirm({
              content: "修改父菜单层级将会导致下级菜单全部删除，保存请谨慎！",
              onOk() {
                self.isLoading = true;
                doPost(action, postData);
              },
              onCancel() {
                self.isLoading = false;
              }
            });
          } 
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  async created() {
    let systemId = this.modalData.cid
    if(this.formType==="edit"){
      systemId=this.modalData.systemId
    }
     await this.$service
      .post("getAllFunctionBySys", {
         systemId:systemId,
       },
      )
      .then(result => {
        if (result.$.checkResult(result, true)) {
            this.datalist = result.data.concat([]);
        }
      });
    if (this.formType === "edit") {
      let {
        fid,
        name,
        parentCode,
        url,
        icon,
        sort,
        status,
        systemId
      } = this.modalData;
      this.formData.fid = fid;
      this.formData.name = name;
      this.formData.url = url;
      this.formData.icon = icon;
      this.formData.sort = sort;
      this.formData.status = status;
      this.formData.systemId = systemId;
      this.formData.parentCode = parentCode;
    }
      if(this.formType==="add"){
      if(this.modalData.level===1){
         this.formData.parentCode='ROOT';
          this.formData.code= 'ROOT';
       }else{
         this.formData.parentCode=this.modalData.parentName;
          this.formData.code= this.modalData.parentName;
       }
    }
  },
 mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.select-btn__span {
  display: inline-block;
  border-radius: 3px;
  background-color: #1895dd;
  min-width: 65px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
}
.modal-modify-takeawaySys {
  padding-left: 24px;
}
.content {
  padding: 20px 30px;
  height: 100%;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.select__btn {
  margin-left: 8px;
  vertical-align: top;
}
.type__chk {
  margin: {
    top: 5px;
    right: 64px;
  }
}
.input-tips {
  margin-left: 10px;
}
</style>